import axios from 'axios';
import {publicIp, publicIpv4, publicIpv6} from 'public-ip';
const SignupRequest = async(phone_number) => {
    try {
        return await axios.post(
          process.env.REACT_APP_API_URL + 'authentication/signup',
          {
            phone_number: phone_number
          },
          {
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }
        );
      } catch (error) {
        console.error('Error:', error);
        return Promise.reject(error);
      }
};

const validateOtp = async (phoneNumber, otp) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/validate-otp';
  const data = {
    phone_number: phoneNumber,
    otp: otp
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
    // Token expiry is now managed by Keycloak directly
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    return Promise.reject(error);
  }
};


const signInOtp = async (phoneNumber) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/signin-otp';
  const data = {
    phone_number: phoneNumber,
  };

  try {
    return await axios.post(url, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    return Promise.reject(error); // Reject the promise with the error
  }
};
const googleLoginApi = async (credential) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/google-login';
  const guest_uuid = localStorage.getItem('yooki_guest_uuid') || undefined;
  const response = await axios.post(url, { credential, guest_uuid }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (response.data?.access_token) {
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
  }
  return response.data;
};

const sendMobileOtp = async (phoneNumber) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/mobile-login';
  const response = await axios.post(url, { phone_number: phoneNumber }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

const verifyMobileOtp = async (phoneNumber, otp) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/mobile-validate-otp';
  const guest_uuid = localStorage.getItem('yooki_guest_uuid') || undefined;
  const response = await axios.post(url, { phone_number: phoneNumber, otp: otp, guest_uuid }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (response.data?.access_token) {
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
  }
  return response.data;
};

const sendEmailOtp = async (email) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/email-login';
  const response = await axios.post(url, { email: email }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

const verifyEmailOtp = async (email, otp) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/email-validate-otp';
  const guest_uuid = localStorage.getItem('yooki_guest_uuid') || undefined;
  const response = await axios.post(url, { email: email, otp: otp, guest_uuid }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (response.data?.access_token) {
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
  }
  return response.data;
};

const refreshTokens = async () => {
  const url = process.env.REACT_APP_API_URL + 'authentication/refresh';
  const refreshToken = localStorage.getItem('refresh_token');
  const accessToken = localStorage.getItem('access_token');

  if (!refreshToken) {
    return Promise.reject("Not Authenticated");
  }

  const data = {
    access_token: accessToken || '',
    refresh_token: refreshToken
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    if (response.data?.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
    }
    return response;
  } catch (error) {
    console.error('Error refreshing tokens:', error.response ? error.response.data : error.message);
    return Promise.reject(error);
  }
};


const authenticateUser = async ( loginType, email, password, phoneNumber, otp ) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/token';
  const data = {
    login_type: loginType || 'phone',
    email: email || '',
    password: password || '',
    phone_number: phoneNumber  || '',
    otp: otp || '',
  };
  const ipaddress = await publicIpv4();
  try {
    const response =  await axios.post(url, data, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Forwarded-For' : ipaddress
      },
    });
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
    // Token expiry is now managed by Keycloak directly
    return response
    
  } catch (error) {
    return Promise.reject(error); // Reject the promise with the error
  }
};

const signupDetails = async (email, password, first_name, phone_number) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/signup-details';
  const data = {
    email: email,
    password: password,
    first_name: first_name,
    phone_number: phone_number,
  };

  try {
    const access_token = localStorage.getItem('access_token')
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }
    const response = await axios.post(url, data, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access_token}`, // Include the access token in the header
      },
    });

    return response.data; // Return the response data
  } catch (error) {
    console.error(
      'Error during signup:',
      error.response ? error.response.data : error.message
    );
    return Promise.reject(error); // Reject the promise with the error
  }
};

const getProfile = async () => {
  const url = process.env.REACT_APP_API_URL + 'authentication/profile';
  const access_token = localStorage.getItem('access_token')
  // console.log("access_token-profile",access_token);
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }
  try {
    const response = await axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${access_token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error.response ? error.response.data : error.message);
    return Promise.reject(error); // Reject the promise with the error
  }
};


const logoutUser = async () => {
  const url = process.env.REACT_APP_API_URL + 'authentication/logout';

  const access_token = localStorage.getItem('access_token')
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }

  try {
    const response = await axios.post(
      url,
      {}, // No data is sent in the body
      {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${access_token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error during logout:', error.response?.data || error.message);
    return Promise.reject(error);
  }
};

const updateUserDetails = async (first_name,last_name,email, gender, age, phone_number) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/update';
  const data = {
    first_name: first_name !== undefined && first_name !== null ? first_name.trim() : "",
    last_name: last_name !== undefined && last_name !== null ? last_name.trim() : "",
    email: email ? email.trim() : "",
    phone_number: phone_number && String(phone_number).trim() !== "" ? String(phone_number).trim() : null,
    gender: gender ? gender.trim() : "",
    age: age && !isNaN(parseInt(age, 10)) ? parseInt(age, 10) : null,
  };
  const access_token = localStorage.getItem('access_token')
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }


  try {
    const response = await axios.patch(url, data, {
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const deleteAllChatHistory = async () => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "history/all",
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to delete chat history");
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting chat history:", error);
    throw error;
  }
};

export const sendVerificationOtp = async (type, value) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/send-verification-otp';
  const access_token = localStorage.getItem('access_token');
  if (!access_token) return Promise.reject("unauthorized");
  const response = await axios.post(
    url,
    { type, value },
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const confirmVerificationOtp = async (type, value, otp) => {
  const url = process.env.REACT_APP_API_URL + 'authentication/confirm-verification-otp';
  const access_token = localStorage.getItem('access_token');
  if (!access_token) return Promise.reject("unauthorized");
  const response = await axios.post(
    url,
    { type, value, otp },
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export {
  SignupRequest,
  validateOtp,
  signInOtp,
  refreshTokens,
  authenticateUser,
  signupDetails,
  getProfile,
  logoutUser,
  updateUserDetails,
  googleLoginApi,
  sendMobileOtp,
  verifyMobileOtp,
  sendEmailOtp,
  verifyEmailOtp,
};
